import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Calendar } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function ClientMeetingsSection({ clientId, meetings }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-serif font-bold text-foreground flex items-center gap-2">
          <Calendar className="w-5 h-5" />
          Meetings
        </h2>
        <button
          onClick={() => navigate(`/meetings/new?client=${clientId}`)}
          className="text-primary hover:text-primary/80 text-sm flex items-center gap-1"
          data-testid="add-meeting-button"
        >
          <Plus className="w-4 h-4" />
          New
        </button>
      </div>
      {meetings.length === 0 ? (
        <div className="bg-surface border border-border rounded-lg p-4 text-center text-text-muted text-sm">
          No meetings yet
        </div>
      ) : (
        <div className="space-y-2">
          {meetings.map((meeting) => (
            <div
              key={meeting.id}
              className="bg-surface border border-border rounded-lg p-3"
              data-testid={`meeting-${meeting.id}`}
            >
              <div className="flex items-start justify-between mb-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-medium text-foreground">{meeting.title}</h3>
                  {meeting.booked_by_client && (
                    <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full border border-primary/20">
                      self-booked
                    </span>
                  )}
                </div>
                <StatusBadge status={meeting.status} />
              </div>
              <p className="text-sm text-text-secondary">
                {meeting.date} {meeting.time && `at ${meeting.time}`}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
